import { useCallback, useState, useEffect } from "react";
import { Pagination } from "../../Common/Pagination";
import { Table } from "../../Common/Table";
import { useNavigate } from "react-router-dom";
import { PlanSUmmaryModel } from "../../Model/PlanSUmmaryModel";
import { getCustomerList } from "../../Redux/Slice/Customers/CustomerListSlice";
import {
  setPage,
  setTotalItems,
  setTotalPages,
} from "../../Redux/Slice/Common/PaginationSlice";
import { DeleteCustomer } from "../../Redux/Slice/Customers/DeleteCustomerSlice";
import { SuccessModel } from "../../Model/SuccessModel";
import { ErrorModel } from "../../Model/ErrorModel";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { debounce } from "../../Common/debounce";
import { dateFormat } from "../../Common/DateAndTimeFormat";
import { Loader } from "../../Common/Loader";
import useDebounce from "../../Common/useDebounce";
import { LIMIT_PER_PAGE } from "../../Common/Constants";

export const CustomerList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" });
  const [planSUmamryModel, setPlanSUmmaryModel] = useState(false);
  const [searchText, setSearchText] = useState("");
  const searchQuery = useDebounce(searchText, 500);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [confirmModel, setCOnfirmModel] = useState(false);
  const [selectedRow, setselectedRow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cutomerList, setCustomerList] = useState([]);
  const [localItemsPerPage, setLocalItemsPerPage] = useState(LIMIT_PER_PAGE);

  const customers = useSelector((state) => state.customerList.customerDetails);

  const getCustomersList = async (page = 1, limit) => {
    setIsLoading(true);
    const result = await dispatch(getCustomerList({ searchText, page, limit }));
    await dispatch(setPage(result?.payload?.pagination?.currentPage));
    await dispatch(setTotalItems(result?.payload?.pagination?.totalItems));
    await dispatch(setTotalPages(result?.payload?.pagination?.totalPages));
    setIsLoading(false);
  };

  const setPageList = (customers) => {
    if (!!customers) {
      return customers.map((item, index) => {
        return {
          id: item.id,
          avatar: item?.admin?.avatar,
          count: index + 1,
          companyName: item.companyName,
          adminName: item.admin
            ? item.admin?.firstName + " " + item.admin?.lastName
            : "",
          email: item.email,
          joiningDate: item.createdAt ? dateFormat(item.createdAt) : "",
          planName: item.plan?.name,
          creditsPending: item.credits,
          expiryDate: item.expiryDate,
          autoTopUpDate: item.autoTopUpDate,
          planId: item?.plan?.id,
          logo: item?.logo,
        };
      });
    }
  };
  // useEffect(() => {
  //   getCustomersList(1);
  // }, []);
  useEffect(() => {
    if (customers) {
      setCustomerList(customers.data);
    }
  }, [customers]);

  const debouncedGetCustomerList = useCallback(
    debounce(getCustomersList, 300),
    [searchQuery]
  );

  useEffect(() => {
    debouncedGetCustomerList(1, localItemsPerPage);
  }, [searchQuery, debouncedGetCustomerList]);

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDateRange({ ...dateRange, [name]: value });
  };

  const onEdit = (rowData) => {
    navigate("/edit-customer/" + rowData.id);
  };
  const onDelete = (rowData) => {
    setCOnfirmModel(true);
    setselectedRow(rowData);
  };

  const onDeleteConfirm = async () => {
    setCOnfirmModel(false);

    const result = await dispatch(DeleteCustomer(selectedRow.id));

    if (
      DeleteCustomer.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setSuccessMessage("Customer Deleted Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        getCustomersList(1, localItemsPerPage);
      }, 1500);
    } else {
      //TODO: error popup here
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const onView = (rowdata) => {
    setselectedRow(rowdata);
    setPlanSUmmaryModel(true);
  };

  const onRemove = () => {
    setPlanSUmmaryModel(false);
    getCustomersList(1, localItemsPerPage);
  };

  const onCloseSummary = () => {
    setPlanSUmmaryModel(false);
  };

  const columns = [
    {
      label: "Company Name",
      key: "companyName",
      avatarKey: "logo",
      className: "profile__link",
    },
    {
      label: "Admin Name",
      key: "adminName",
      className: "cellText",
    },
    {
      label: "Email",
      key: "email",
      className: "cellText",
    },
    {
      label: "Signed up",
      key: "joiningDate",
      className: "cellText",
    },
    {
      label: "Plan Name",
      key: "planName",
      className: "cellText",
    },
    {
      label: "Credits Pending",
      key: "creditsPending",
      className: "cellText",
    },
    // {
    //   label: "Expiry Date",
    //   key: "expiryDate",
    //   className: "cellText",
    // },
    // {
    //   label: "Auto Top Up Date",
    //   key: "autoTopUpDate",
    //   className: "cellText",
    // },
  ];

  return (
    <>
      {planSUmamryModel ? (
        <PlanSUmmaryModel
          planId={selectedRow}
          onRemove={onRemove}
          onClose={onCloseSummary}
        />
      ) : (
        ""
      )}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {confirmModel ? (
        <ConfirmModel
          onAccept={onDeleteConfirm}
          onReject={() => {
            setCOnfirmModel(false);
          }}
          title="Delete Customer!"
          message="Are you sure you want to Delete the customer?"
        />
      ) : (
        ""
      )}
      {isLoading ? <Loader /> : ""}{" "}
      <div className="page__body">
        <div className="tableWrap">
          <div className="tableWrap__head">
            <div className="formRow m_0  formRow--flexEnd">
              <div className="formCol formCol--flexInput">
                <div className="formCol flexField">
                  <input
                    className="form__input form__input--search"
                    type="text"
                    placeholder="Search a Customer Name or email"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value.trimStart());
                    }}
                  />
                </div>
                {/* <button className="btn btn__white">
                  <svg
                    width="20"
                    height="14"
                    viewBox="0 0 20 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.52637 7H15.5264M1.77637 1.5H18.2764M7.27637 12.5H12.7764"
                      stroke="#475569"
                      stroke-width="1.837"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Filter
                </button> */}
              </div>
              {/* <div className="formCol formCol--flex">
                <label for="date" className="form__label">
                  Date
                </label>
                <div className="formRow formRow__2">
                  <div className="formCol">
                    <div className="form__Field">
                      <input
                        type="date"
                        className="form__date form__date--sm"
                        value={dateRange.startDate}
                        name="startDate"
                        onChange={handleDateChange}
                        placeholder="DD/MM/YYYY"
                      />
                    </div>
                  </div>
                  <div className="formCol">
                    <div className="form__Field">
                      <input
                        type="date"
                        id="joiningDate"
                        className="form__date form__date--sm"
                        value={dateRange.endDate}
                        name="endDate"
                        onChange={handleDateChange}
                        placeholder="DD/MM/YYYY"
                      />
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            <div className="btn__group">
              <button
                className="btn btn__primary"
                onClick={() => {
                  navigate("/add-customer");
                }}
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.00008 1.1665V12.8332M1.16675 6.99984H12.8334"
                    stroke="white"
                    stroke-width="1.67"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Add Customer
              </button>
            </div>
          </div>
          <Table
            columns={columns}
            data={setPageList(cutomerList)}
            onDelete={onDelete}
            onEdit={onEdit}
            onView={onView}
            hasAction="true"
            onClickLink={(rowData) => {
              navigate(`/customerUser/${rowData?.id}`, {
                state: {
                  companyName: rowData?.companyName,
                },
              });
            }}
          />
        </div>
      </div>
      <Pagination 
        apiMethod={getCustomersList}
        itemsPerPage={localItemsPerPage}
        setItemsPerPage={setLocalItemsPerPage}
      />
    </>
  );
};
